import moment from "moment";
import { toMoney } from "shared/utils";
import { ContentTitle } from "views/applications-id-report/components/ContentTitle";
import { KeyValue } from "views/applications-id-report/components/KeyValue";
import { PaystubDocumentPaystub } from "views/applications-id-report/slices/CombinedIncomeReportSlice/types/verified/paystub";

export const PaystubDetailsSlice = ({
  paystub
}: {
  paystub: PaystubDocumentPaystub;
}) => {
  return (
    <ContentTitle title="Paystub details" contentClassName="space-y-2">
      <KeyValue
        label="Pay period"
        value={`${moment(paystub.paystub_details.pay_period_start_date).format("ll")} - ${moment(
          paystub.paystub_details.pay_period_end_date
        ).format("ll")}`}
      />
      <KeyValue
        label="Pay date"
        value={
          paystub.paystub_details.pay_date &&
          moment(paystub.paystub_details.pay_date).isValid()
            ? moment(paystub.paystub_details.pay_date).format("ll")
            : "-"
        }
      />
      <KeyValue
        label="Net pay"
        value={toMoney(paystub.total_net_pay.cents / 100)}
      />

      <KeyValue
        label="Gross pay"
        value={toMoney(paystub.total_gross_pay.cents / 100)}
      />

      <KeyValue
        label="Provider"
        value={paystub.paystub_details.paystub_provider?.name}
      />

      <KeyValue
        label="Frequency"
        value={paystub.paystub_details.pay_frequency_captured}
      />
    </ContentTitle>
  );
};
